import { ReactNode } from 'react';

export enum InRestaurantScreen {
  /* Displays the QR code */
  QR_CODE = 'QRCode',
  /* Displays the in-restaurant cart list when 1 or more items are added */
  CART_LIST = 'cartList',
  /* Displays when user is not authenticated */
  UNAUTHENTICATED = 'unauthenticated',
  /* Displays when user scans the code successfully on the Kiosk */
  CONFIRMATION = 'confirmation',
}

export type InRestaurantScreenOption = {
  title: string;
  component: NonNullable<ReactNode>;
};

export type InRestaurantScreenVariants = Record<InRestaurantScreen, InRestaurantScreenOption>;
